import React from 'react';

import { FormattedMessage } from 'react-intl';

import { Box, Flex, Inline, xcss } from '@atlaskit/primitives';

import { useIntl } from 'src/hooks/intl';
import { useParams } from 'src/router/hooks';
import urls from 'src/sections/repository/urls';
import { Divider } from 'src/styles';

import { messages } from './i18n';
import simpleWorkflowImageUrl from './simple-workflow.svg';

export const MergeChecksEmptyState = () => {
  const { formatMessage } = useIntl();

  const { repositoryOwner, repositorySlug } = useParams<{
    repositoryOwner: string;
    repositorySlug: string;
  }>();

  return (
    <Box xcss={xcss({ paddingBlock: 'space.200', paddingInline: 'space.150' })}>
      <Flex direction="column" gap="space.100">
        <Inline
          alignBlock="center"
          alignInline="center"
          xcss={xcss({ marginBottom: 'space.100' })}
        >
          <img
            src={simpleWorkflowImageUrl}
            alt={formatMessage(messages.simpleWorkflowAltText)}
            height="124px"
          />
        </Inline>

        <FormattedMessage {...messages.emptyStateDescriptionFirst} />
        <FormattedMessage {...messages.emptyStateDescriptionSecond} />
        <Divider />
        <Flex direction="column" gap="space.100" alignItems="center">
          <a href={urls.ui.branchPermissions(repositoryOwner, repositorySlug)}>
            <FormattedMessage {...messages.setupMergeChecks} />
          </a>
          <a href={urls.ui.customMergeChecks(repositoryOwner, repositorySlug)}>
            <FormattedMessage {...messages.setupCustomChecks} />
          </a>
        </Flex>
      </Flex>
    </Box>
  );
};
